import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import HowItWorksPage from '@/pages/HowItWorksPage';
import WhyItWorksPage from '@/pages/WhyItWorksPage';
import BuddiesPage from '@/pages/BuddiesPage';
import ParentsPage from '@/pages/ParentsPage';
import SafetyPage from '@/pages/SafetyPage';
import ForSchoolsPage from '@/pages/ForSchoolsPage';
import SchoolLeadersPage from '@/pages/SchoolLeadersPage';
import FAQPage from '@/pages/FAQPage';
import ContactPage from '@/pages/ContactPage';
import IframePage from '@/pages/IframePage';
import RoadmapPage from '@/pages/RoadmapPage';
import { Toaster } from '@/components/ui/toaster';
import { AnimatePresence, motion } from 'framer-motion';
import TrainingenPage from '@/pages/TrainingenPage';
import GebruikersvoorwaardenPage from '@/pages/GebruikersvoorwaardenPage';
import PrivacybeleidPage from '@/pages/PrivacybeleidPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const PageTransition = ({ children }) => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -30, scale: 0.98 }}
        transition={{ duration: 0.5, ease: [0.6, -0.05, 0.01, 0.99] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen relative">
        {/* Mobile background - only visible on mobile and fixed to viewport */}
        <div 
          className="sm:hidden fixed inset-0 z-0"
          style={{
            backgroundImage: `url('/lovable-uploads/406814e4-505a-4cc0-ade1-8c79fc08ba1d.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '100vh',
            width: '100vw'
          }}
        />
        
        {/* Desktop background - only visible on desktop */}
        <div 
          className="hidden sm:block fixed inset-0 z-0"
          style={{
            backgroundImage: `url('/lovable-uploads/3057fc9d-6b6d-44c2-807b-b680fe646456.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        />

        <div className="relative z-10 flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <PageTransition>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/over-ons" element={<AboutPage />} />
                <Route path="/hoe-werkt-het" element={<HowItWorksPage />} />
                <Route path="/waarom-werkt-het" element={<WhyItWorksPage />} />
                <Route path="/buddys" element={<BuddiesPage />} />
                <Route path="/ouders" element={<ParentsPage />} />
                <Route path="/voor-scholen" element={<ForSchoolsPage />} />
                <Route path="/schoolleiders" element={<SchoolLeadersPage />} />
                <Route path="/trainingen" element={<TrainingenPage />} />
                <Route path="/veiligheid" element={<SafetyPage />} />
                <Route path="/roadmap" element={<RoadmapPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/gebruikersvoorwaarden" element={<GebruikersvoorwaardenPage />} />
                <Route path="/privacybeleid" element={<PrivacybeleidPage />} />
                <Route path="/jouw-horizons-app" element={<IframePage />} />
                <Route path="/login" element={
                  <div className="container mx-auto px-4 py-16 text-center section-padding">
                    <h1 className="page-title">Inloggen</h1>
                    <p className="page-subtitle">Deze pagina is nog in ontwikkeling. Kom snel terug!</p>
                  </div>
                } />
              </Routes>
            </PageTransition>
          </main>
          <Footer />
          <Toaster />
        </div>
      </div>
    </Router>
  );
}

export default App;
